import { FileText, Download } from "lucide-react";

const DOC_TYPE_LABELS = {
  brief: "Brief",
  production_schedule: "Production Schedule",
  storyboard: "Storyboard",
  shot_list: "Shot List",
  delivery_notes: "Delivery Notes",
  moodboard: "Moodboard",
  invoice: "Invoice",
  other: "Document",
};

/** Client Portal v2 (2026-09, Phase 1, §6) — lightweight, staff-uploaded, client-tagged
 * documents (Mongo + Drive only, see modules/client_documents.py — never SOW/commercial docs).
 * §6 adds "invoice" as a taggable type (same scoping/visibility as every other type — nothing
 * new to gate here, `DOC_TYPES` in the backend already allow-lists it). Downloads proxy through
 * the app's own file endpoint. Restyled to calm Title/Type/Date rows on the light surface. */
export function DocumentsList({ documents, fileUrl }) {
  if (!documents || documents.length === 0) {
    return (
      <p className="text-[13.5px] text-[color:var(--cp-grey-3)]" data-testid="client-portal-documents-empty">Shared documents (briefs, schedules, storyboards, invoices) will appear here.</p>
    );
  }
  return (
    <div data-testid="client-portal-documents-list">
      {documents.map((d) => (
        <a
          key={d.id}
          href={fileUrl(d.id)}
          target="_blank"
          rel="noreferrer"
          data-testid={`client-portal-document-${d.id}`}
          className="cp-row-divider flex items-center justify-between gap-4 py-3.5 hover:bg-black/[.02] transition-colors -mx-2 px-2"
        >
          <div className="flex items-center gap-3.5 min-w-0">
            <FileText className="h-4 w-4 text-[color:var(--cp-grey-3)] shrink-0" />
            <div className="min-w-0">
              <div className="text-[13.5px] font-medium text-[color:var(--cp-ink-text)] truncate">{d.title}</div>
              <div className="text-[10.5px] font-semibold uppercase tracking-wide text-[color:var(--cp-grey-4)]">{DOC_TYPE_LABELS[d.doc_type] || "Document"}</div>
            </div>
          </div>
          <Download className="h-4 w-4 text-[color:var(--cp-grey-4)] shrink-0" />
        </a>
      ))}
    </div>
  );
}
